import(/* webpackMode: "eager" */ "/var/www/smartguy/node_modules/.pnpm/next@15.5.7_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Figtree\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-figtree\"}],\"variableName\":\"figtree\"}");
;
import(/* webpackMode: "eager" */ "/var/www/smartguy/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ActivityTracker"] */ "/var/www/smartguy/src/components/common/LastActivityReporter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartguy/src/components/GoogleTag.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartguy/src/components/providers/session-provider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartguy/src/components/providers/toast-provider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/smartguy/src/components/ui/sonner.jsx");
